var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header-outer"},[_c('span',{staticClass:"header-title"},[_vm._v("韶关市农村产权流转交易大数据")])])}]

export { render, staticRenderFns }